import React from 'react';
import { Card } from '../ui/Card';
import { FileCheck, Plane, Users, GraduationCap, FileText, HeartHandshake } from 'lucide-react';
const services = [{
  title: 'Admission Processing',
  description: 'We handle the entire application process, from university selection to submitting your documents, ensuring error-free applications.',
  icon: FileCheck,
  color: 'bg-blue-100 text-blue-600'
}, {
  title: 'Visa Guidance',
  description: 'Expert assistance with visa requirements, documentation, and interview preparation to maximize your approval chances.',
  icon: Plane,
  color: 'bg-green-100 text-green-600'
}, {
  title: 'Career Counseling',
  description: 'Personalized guidance to help you choose the right course and university that aligns with your career goals and aspirations.',
  icon: Users,
  color: 'bg-amber-100 text-amber-600'
}];
export function ServicesSection() {
  return <section className="py-20 bg-white" data-id="element-96">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-97">
        <div className="text-center mb-16" data-id="element-98">
          <span className="text-[#f59e0b] font-semibold tracking-wider uppercase text-sm" data-id="element-99">
            Our Expertise
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mt-2 mb-4" data-id="element-100">
            Comprehensive Student Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-101">
            We support you at every step of your journey, from the moment you
            decide to study abroad until you settle in your new destination.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-102">
          {services.map((service, index) => <Card key={service.title} className="text-center h-full hover:border-[#f59e0b]/30 transition-colors duration-300" hoverEffect data-id="element-103">
              <div className={`w-16 h-16 mx-auto rounded-2xl flex items-center justify-center mb-6 ${service.color}`} data-id="element-104">
                <service.icon className="h-8 w-8" data-id="element-105" />
              </div>
              <h3 className="text-xl font-bold text-[#1e3a5f] mb-4" data-id="element-106">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-107">
                {service.description}
              </p>
            </Card>)}
        </div>
      </div>
    </section>;
}